import { useSelector } from 'react-redux';
import cuba from '../municipios.svg'
import { MunicipioStatus } from '../types';
import { RootState } from '../store';
import { Wifi, WifiOff } from 'lucide-react';
import { useSignalR } from '../context/SignalRContext';

function Legend() {
    const map = useSelector((state: RootState) => state.map)
    const { conectado } = useSignalR();

    function getStatusStats(status: MunicipioStatus){
        const statusCount = map.items.filter(m => m.status === status).length
        const statusPercent = Math.round((statusCount * 100)/map.items.length)
        const statusReports = map.items.filter(m => m.status === status)
                                .reduce((acc, mun) => { return acc + mun.reports.length }, 0)
        return { 
            statusCount: statusCount,
            statusPercent: statusPercent,
            statusReports: statusReports
            }
    }

    return (
        <div className='legend-container'>
            <header>Leyenda  
                {conectado ? <Wifi /> : <WifiOff/>}
            </header>
            <div>                
                <section>
                    <img src={cuba} alt="Cuba Bajo Régimen Castro-Comunista" className='map-regimen legend-map' />
                    <output>
                        <span><b>Bajo régimen Castro-Comunista</b></span>
                        <span> - {getStatusStats('regimen').statusCount} Municipios </span>
                        <span> - {(map.items.length > 0) ? getStatusStats('regimen').statusPercent : 0}% de Cuba</span>
                    </output>
                </section>            
                <section>
                    <img src={cuba} alt="Cuba Bajo Régimen Castro-Comunista" className='map-protestando legend-map' />
                    <output>
                        <span><b>Protestando</b></span>
                        <span> - {getStatusStats('protestando').statusCount} Municipios </span>
                        <span> - {(map.items.length > 0) ? getStatusStats('protestando').statusPercent : 0}% de Cuba</span>
                        <span> - {getStatusStats('protestando').statusReports} Reportes</span>
                    </output>
                </section>            
                <section>
                    <img src={cuba} alt="Cuba Bajo Régimen Castro-Comunista" className='map-lucha legend-map' />
                    <output>
                        <span><b>En pie de lucha</b></span>
                        <span> - {getStatusStats('lucha').statusCount} Municipios </span>
                        <span> - {(map.items.length > 0) ? getStatusStats('lucha').statusPercent : 0}% de Cuba</span>
                        {  <span> - {getStatusStats('lucha').statusReports} Reportes</span>}
                    </output>
                </section>            
                <section>
                    <img src={cuba} alt="Cuba Bajo Régimen Castro-Comunista" className='map-libertad legend-map' />
                    <output>
                        <span><b>Territorio en Libertad</b></span>
                        <span> - {getStatusStats('libertad').statusCount} Municipios </span>
                        <span> - {(map.items.length > 0) ? getStatusStats('libertad').statusPercent : 0}% de Cuba</span>
                    </output>
                </section>            
            </div>
        </div>
    )
}

export default Legend